import { render } from "./index.vue?vue&type=template&id=827411fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=827411fa&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-827411fa"

export default script